import CarouselCards from 'components/landing-pages-v2/CarouselSection/CarouselCards';
import ContactSection from 'components/landing-pages-v2/ContactSection';
import HeroV2 from 'components/landing-pages-v2/HeroV2';
import HeroV2WithMarkers from 'components/landing-pages-v2/HeroV2WithMarkers';
import LWCHeroCard from 'components/landing-pages-v2/LWCHeroCard';
import LWCImageCard from 'components/landing-pages-v2/LWCImageCard';
import LWCTextSection from 'components/landing-pages-v2/LWCTextSection';
import MapBackgroundHero from 'components/landing-pages-v2/MapBackgroundHero';
import Spacer from 'components/landing-pages-v2/Spacer';
import StandaloneText from 'components/landing-pages-v2/StandaloneText';

import IEntryLookup from './entries';

const homePageV2EntryLookup: IEntryLookup = {
  // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
  // for performance
  block: {
    lpComponentMapBackgroundHero: MapBackgroundHero,
    lpComponentCarouselCards: CarouselCards,
    lpComponentContactSection: ContactSection,
    lpComponentLwcTextSection: LWCTextSection,
    lpComponentLwcHeroCard: LWCHeroCard,
    lpComponentLwcImageCard: LWCImageCard,
    lpComponentHeroV2: HeroV2,
    lpComponentHeroV2WithMarkers: HeroV2WithMarkers,
    lpComponentSpacer: Spacer,
    lpComponentStandaloneText: StandaloneText,
  },
  inline: {},
};

export default homePageV2EntryLookup;
